import React from "react";
import "./chubb_pa_series_b.css";

/**
 * Chubb — PA Series B (Plan 1–8 + Kid)
 * Zero-index safe: ไม่มี {index} ใน JSX และคีย์ map มาจากข้อมูลจริง
 * เติมตัวเลขจากเอกสาร Series B ลงในอาร์เรย์ด้านล่างได้ทันที
 */

const fmt = (x) => (x === null || x === undefined ? "—" : (typeof x === "number" ? x.toLocaleString() : x));

const PLANS = ["แผน 1","แผน 2","แผน 3","แผน 4","แผน 5","แผน 6","แผน 7","แผน 8","บุตร Kid"];

// ===== ผลประโยชน์ต่อแผน (ใส่ตัวเลขตามแผนจากเอกสาร) =====
const benefits = [
  { key: "life",    name: "1. อุบัติเหตุทั่วไป (ชีวิต/สูญเสียอวัยวะ/ทุพพลภาพถาวร)", vals: [100000,200000,300000,500000,700000,1000000,2000000,3000000,50000] },
  { key: "murder",  name: "1.2 ฆาตกรรม/ทำร้ายร่างกาย",                        vals: [100000,200000,300000,500000,700000,1000000,2000000,3000000,50000] },
  { key: "moto",    name: "1.3 อุบัติเหตุรถจักรยานยนต์",                       vals: [50000,100000,150000,250000,350000,500000,1000000,1500000,25000] },
  { key: "terror",  name: "1.4 การก่อการร้าย",                                  vals: [0,0,0,0,0,0,0,0,0] }, // ถ้าไม่มี ให้ใส่ 0/เว้นว่างตามเอกสาร
  { key: "holiday", name: "1.5/1.6 วันหยุดสาธารณะ/พาหนะสาธารณะ (เพิ่มทุน)",   vals: [100000,200000,300000,500000,700000,1000000,2000000,3000000,50000] },
  { key: "funeral", name: "2. ค่าปลงศพ (เหตุอุบัติเหตุ)",                      vals: [10000,10000,10000,10000,10000,10000,10000,10000,5000] },
  { key: "med",     name: "3. ค่ารักษาพยาบาลต่อครั้ง (รวมมอเตอร์ไซค์)",        vals: [/* ใส่เลขตามแผน */] },
  { key: "dental",  name: "4. ค่าทันตกรรมจากอุบัติเหตุ",                       vals: [/* ใส่เลขตามแผน */] },
  { key: "fract",   name: "5. กระดูกแตก/ร้าว/ทิ่มทะลุ (ตามตารางผลประโยชน์)",   vals: [/* ใส่เลขตามแผน */] },
  { key: "hap",     name: "6–8 HAP/Smart Money/ICU (ถ้ามีในชุดแผน)",            vals: [/* กรอกตัวเลขหรือใส่ '—' */] },
  { key: "edu",     name: "10. กองทุนการศึกษา บุตร (ถ้ามี)",                    vals: [/* ... */] },
];

// ===== เบี้ยรายปี (รวมอากร/แสตมป์) — PA1 และ PA2 =====
const premiums = {
  PA1: [
    { key: "main",   label: "ผู้เอาประกันหลัก (PA1)",                     vals: [269,499,739,1209,1609,2209,4109,5509,null] },
    { key: "spouse", label: "ผู้เอาประกัน + คู่สมรส (PA1)",                 vals: [509,959,1429,2349,3129,4299,7999,10729,null] },
    { key: "kids2",  label: "ผู้เอาประกัน + บุตร ≤ 2 คน (PA1)",             vals: [719,949,1189,1659,2059,2659,4559,5959,null] },
    { key: "kids3",  label: "ผู้เอาประกัน + บุตร ≤ 3 คน (PA1)",             vals: [959,1409,1979,2759,3579,4749,8149,11179,null] },
  ],
  PA2: [
    { key: "main",   label: "ผู้เอาประกันหลัก (PA2)",                     vals: [349,649,969,1559,2009,2809,5309,7009,null] },
    { key: "spouse", label: "ผู้เอาประกัน + คู่สมรส (PA2)",                 vals: [669,1259,1865,3029,3969,5469,9935,13265,null] },
    { key: "kids2",  label: "ผู้เอาประกัน + บุตร ≤ 2 คน (PA2)",             vals: [919,1219,1619,2149,2799,3659,6435,8659,null] },
    { key: "kids3",  label: "ผู้เอาประกัน + บุตร ≤ 3 คน (PA2)",             vals: [1219,1629,2029,2429,3579,5019,8829,10489,null] },
  ],
};

export default function ChubbPASeriesBDetails({ onQuote }) {
  return (
    <div className="pkg-detail chubb-pa-b">
      <h2>Chubb PA Series B — แผน 1–8 + Kid</h2>
      <p className="pkg-note">
        อายุรับ 15–70 ปี ต่ออายุได้ถึง 75 ปี • เด็ก 6 เดือน–23 ปี (ตามเงื่อนไข) •
        มีแพ็กเดี่ยว/คู่สมรส/ครอบครัว • เบี้ยรวมอากรแสตมป์
      </p>

      <h3 className="pkg-section">ผลประโยชน์ต่อแผน</h3>
      <table className="pkg-table">
        <thead>
          <tr>
            <th className="pkg-left">ความคุ้มครอง</th>
            {PLANS.map((p) => <th key={`plan-${p}`}>{p}</th>)}
          </tr>
        </thead>
        <tbody>
          {benefits.map((b) => (
            <tr key={`bf-${b.key}`}>
              <td className="pkg-left">{b.name}</td>
              {(b.vals || []).map((v, i) => <td key={`bf-${b.key}-${i}`}>{fmt(v)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>

      <h3 className="pkg-section">เบี้ยรายปี (PA1)</h3>
      <table className="pkg-table">
        <thead>
          <tr>
            <th className="pkg-left">รูปแบบผู้เอาประกัน</th>
            {PLANS.map((p) => <th key={`pa1h-${p}`}>{p}</th>)}
          </tr>
        </thead>
        <tbody>
          {premiums.PA1.map((row) => (
            <tr key={`pa1-${row.key}`}>
              <td className="pkg-left">{row.label}</td>
              {row.vals.map((v, i) => <td key={`pa1-${row.key}-${i}`}>{fmt(v)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>

      <h3 className="pkg-section">เบี้ยรายปี (PA2)</h3>
      <table className="pkg-table">
        <thead>
          <tr>
            <th className="pkg-left">รูปแบบผู้เอาประกัน</th>
            {PLANS.map((p) => <th key={`pa2h-${p}`}>{p}</th>)}
          </tr>
        </thead>
        <tbody>
          {premiums.PA2.map((row) => (
            <tr key={`pa2-${row.key}`}>
              <td className="pkg-left">{row.label}</td>
              {row.vals.map((v, i) => <td key={`pa2-${row.key}-${i}`}>{fmt(v)}</td>)}
            </tr>
          ))}
        </tbody>
      </table>

      <ul className="pkg-bullets">
        <li>Kid = บุตรอายุ 6 เดือน–23 ปี (ตามเงื่อนไขบริษัท)</li>
        <li>บางผลประโยชน์/แผนอาจไม่คุ้มครองอาชีพบางประเภท—โปรดตรวจสอบก่อนเสนอขาย</li>
      </ul>

      <div className="pkg-foot">
        <button className="pkg-quote-btn" onClick={onQuote} aria-label="ขอใบเสนอราคา Chubb PA Series B">
          ขอใบเสนอราคา
        </button>
      </div>
    </div>
  );
}
